module.exports = __webpack_public_path__ + "media/images/document-icon-1710d7ba.svg";